
<div :key="master_key"
     class="h-100">
  <div class="search">
    <search :o="$data"></search>
  </div>
  <div class="d-flex p-1 pb-2 header"
       style="height: 45px">
    <div class="d-flex filters align-items-center mr-2 position-relative">
      <i class="fas fa-filter text-secondary mr-2" aria-hidden="true"></i>
      <div class="filter-dropdown-wrapper"
           ref="filterDropdownWrapper">
        <button class="btn btn-outline-secondary btn-sm filter-dropdown-btn"
                @click="toggleFilterDropdown()">
          <span v-if="activeFilterCount === 0">All Billing Types</span>
          <span v-else>Filters ({{ activeFilterCount }})</span>
          <i class="fas fa-chevron-down ml-2"></i>
        </button>
        <div v-if="filterDropdownOpen" class="filter-dropdown-menu">
          <div class="filter-columns">
            <div class="filter-column">
              <!-- Schedule Section -->
              <div class="filter-section">
                <div class="filter-section-title">Schedule</div>
                <label class="filter-radio">
                  <input type="radio" 
                         name="schedule"
                         :value="null"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Any</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="schedule"
                         value="Monthly"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Monthly</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="schedule"
                         value="Quarterly"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Quarterly</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="schedule"
                         value="Semi-Annually"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Semi-Annually</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="schedule"
                         value="Annually"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Annually</span>
                </label>
                <label class="filter-radio">
                  <input type="radio"
                         name="schedule"
                         value="Quarterly 2"
                         v-model="selectedFilters.schedule"
                         @change="handleFilterChange()">
                  <span>Quarterly 2</span>
                </label>
              </div>

              <!-- Type Section -->
              <div class="filter-section">
                <div class="filter-section-title">Type</div>
                <label class="filter-radio">
                  <input type="radio" 
                         name="type"
                         :value="null"
                         v-model="selectedFilters.type"
                         @change="handleFilterChange()">
                  <span>Any</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="type"
                         value="advance"
                         v-model="selectedFilters.type"
                         @change="handleFilterChange()">
                  <span>Advance</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="type"
                         value="arrears"
                         v-model="selectedFilters.type"
                         @change="handleFilterChange()">
                  <span>Arrears</span>
                </label>
              </div>
            </div>
            
            <div class="filter-column">
              <!-- Billing Status Section -->
              <div class="filter-section">
                <div class="filter-section-title">Billing Status</div>
                <label class="filter-radio">
                  <input type="radio" 
                         name="billingStatus"
                         :value="null"
                         v-model="selectedFilters.billingStatus"
                         @change="handleFilterChange()">
                  <span>Any</span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="billingStatus"
                         value="ready"
                         v-model="selectedFilters.billingStatus"
                         @change="handleFilterChange()">
                  <span><span class="filter-badge badge-ready">Ready</span></span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="billingStatus"
                         value="billed"
                         v-model="selectedFilters.billingStatus"
                         @change="handleFilterChange()">
                  <span><span class="filter-badge badge-billed">Billed</span></span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="billingStatus"
                         value="paid"
                         v-model="selectedFilters.billingStatus"
                         @change="handleFilterChange()">
                  <span><span class="filter-badge badge-paid">Paid</span></span>
                </label>
                <label class="filter-radio">
                  <input type="radio" 
                         name="billingStatus"
                         value="none"
                         v-model="selectedFilters.billingStatus"
                         @change="handleFilterChange()">
                  <span>-- (No Status)</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex actions my-auto pl-2">
      <template v-if="hasSelection">
        <div title="Create Invoice"
             class="btn btn-outline-secondary"
             v-on:click="click('invoice-bulk')">
          <i class="fas fa-file-invoice-dollar"></i>
          <span class="ml-1">Bulk Invoice</span>
        </div>
        <div :title="title('discloseFeeScheduleBulk')"
             class="btn btn-outline-secondary"
             v-on:click="click('discloseFeeScheduleBulk')">
          <i class="fas fa-mail-bulk"></i>
          <span class="ml-1">Disclose Fee Schedule</span>
        </div>
        <!-- disclose annual amendment -->
        <div :title="title('discloseAnnualAmendment')"
             class="btn btn-outline-secondary"
             v-on:click="click('discloseAnnualAmendment')">
          <i class="fas fa-mail-bulk"></i>
          <span class="ml-1">Disclose Annual Amendment</span>
        </div>
      </template>
      <template v-else>
        <div class="d-flex my-auto mr-2 pr-1" >
          <span class="alt-action text-secondary">Select one or more contracts for options</span>
        </div>
      </template>
    </div>
    <div class="flex-grow-1 my-auto text-right" 
    style="display: flex; flex-direction: column; font-size: 0.8rem" >
      <span v-text="recordsSummary"></span>
      <span v-text="selectedSummary"></span>
    </div>
  </div>

  <template v-if="ready">
  <scroll-area class="pr-3">
    <a ref="download"
       class="d-none"></a>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>
            <checkbox :o="selectAllState"
                      p="selected"
                      v-on:change="change()"></checkbox>
          </th>
          <th>
            <span>Id</span>
            <i class="fas fa-sort"
               :class="sortClass(`id`)"
               v-on:click="sort(`id`)"></i>
          </th>
          <th>
            <span>Ref</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`ref`)"
               v-on:click="sort(`ref`)"></i>
          </th>
          <th>
            <span>Billing Type</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`billingType`)"
               v-on:click="sort(`billingType`)"></i>
          </th>
          <th>
            <span>Billing Schedule</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`billingSchedule`)"
               v-on:click="sort(`billingSchedule`)"></i>
          </th>
          <th class="text-nowrap">
            <span>Billing Status</span>
          </th>
          <th>
            <span>Accounts</span>
        <i class="fas fa-sort pl-1"
          :class="sortClass(`accounts`)"
          v-on:click="sort(`accounts`)"></i>
          </th>
          <th>
            <span>Schedules</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`schedules`)"
               v-on:click="sort(`schedules`)"></i>
          </th>
          <th class="text-nowrap">
            <span>Date</span>
            <i class="fas fa-sort pl-1"
               :class="sortClass(`date`)"
               v-on:click="sort(`date`)"></i>
          </th>
          <th class="text-nowrap"></th>
        </tr>
      </thead>
      <tbody :key="bodyKey">
        <tr v-for="(o, index) in limitedItems"
            :key="o._id"
            data-cy="custodian-contract-row">
          <td>
            <checkbox :o="o"
                      p="select"
                      v-on:change="change(o)"
                      :disabled="o.status != `Active`"></checkbox>
          </td>
          <td>
            <a href="#" class="badge badge-custom"
                  :title="title(`contract`)"
                  v-on:click="click(`contract`, o)"
                  v-text="o.id"></a>
          </td>
          <td class="text-nowrap">
            <span>{{ o.ref.split("- ")[0] }}</span>
          </td>
          <td>
            <span style="text-transform: capitalize;">{{ o.billingType }}</span>
          </td>
          <td>
            <span style="text-transform: capitalize;">{{ o.billingSchedule || '-' }}</span>
          </td>
          <td class="text-nowrap">
            <div v-if="o.billingStatus" 
                 class="billing-status-tooltip"
                 :data-tooltip="getBillingStatusTooltip(o.billingStatus.badgeClass)">
              <span :class="`badge badge-${o.billingStatus.badgeClass}`"
                    v-text="o.billingStatus.label"></span>
            </div>
            <span v-else class="text-muted">-</span>
          </td>
          <td class="accounts">
            <div class="accounts-container">
              <span v-for="(a, i) in getVisibleAccounts(o)"
                    :key="i"
                    class="account-badge mr-2"
                    v-text="a"></span>
              <button v-if="o.accounts && o.accounts.length > 3"
                      @click="toggleAccountsExpanded(o._id)"
                      class="btn-expand-accounts">
                {{ expandedAccounts[o._id] ? 'Show Less' : `+${o.accounts.length - 3} more` }}
              </button>
            </div>
          </td>
          <td class="schedules">
            <schedule-badges 
            :schedules="o.schedules" 
            @click="openScheduleModal"></schedule-badges>
          </td>
          <td class="text-nowrap">
            <span v-text="o.date"></span>
          </td>
          <td class="text-nowrap">
            <i class="far fa-file-pdf mr-2"
               :title="title(`pdf`)"
               v-on:click="click(`pdf`, o)"></i>
            <i class="fas fa-dollar-sign mr-2"
               :title="title(`bill`)"
               :class="o.status != `Active` ? `disabled` : ``"
               v-on:click="o.status == `Active` ? click(`bill`, o) : ``"></i>
            <i class="far fa-paper-plane mr-2"
               :title="title(`discloseFeeSchedule`)"
               v-on:click="click(`discloseFeeSchedule`, o)"></i>
            <i v-if="o.showSignatureReminder" class="far fa-bell mr-2"
               :title="title(`reminder`)"
               v-on:click="click(`reminder`, o)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </scroll-area>
</template>
<template v-else>
    <loading></loading>
</template>
</div>
